import React from 'react'
import { LinearProgress } from '@mui/material'

export default class Loader extends React.Component {
  render () {
    return <LinearProgress aria-live="polite" aria-busy="true" aria-label="Loading page..."/>
  }
}
